/*
 * サブシステム名：燃費管理
 * 機能名：燃費ダッシュボード
 */

import DdCustomButton from '@/components/DdCustomButton'
import DdDateRangeBox from '@/components/DdDateRangeBox'
import DdTransparentButton from '@/components/DdTransparentButton'
import DdDropDownMulti from '@/components/DdDropDownMulti'
import DdNenpiSummaryDisp from '@/components/DdNenpiSummaryDisp'
import DdNenpiChartLineBar from '@/components/DdNenpiChartLineBar'

import date from '@/ddv2.library/date'
import modals from '@/ddv2.library/modals'

import flowMixin from '@/mixins/flowMixins'
import validators from '@/rahmen/validators'

import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'

const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdDataTable = () => import('@/components/DdDataTable')
const DdDefaultButton = () => import('@/components/DdDefaultButton')
const DdDropDown = () => import('@/components/DdDropDown')
const DdNarrowDownTextBox = () => import('@/components/DdNarrowDownTextBox')
const DdRadioButton = () => import('@/components/DdRadioButton')
const DdRowCountBox = () => import('@/components/DdRowCountBox')
const DdSelectItemsPerPage = () => import('@/components/DdSelectItemsPerPage')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTextBox = () => import('@/components/DdTextBox')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
export default {
  name: 'NenpiDashBoard',
  mixins: [flowMixin],
  data: () => ({
    // 一覧制御用
    itemsPerPage: 100,
    page: 1,
    isConditionHide: false,
    isExcelDownloader: false,
    activeButtonColor: '#bcced3',
    inActiveButtonColor: '#FFFFFF',
    activeButtonTextColor: 'white--text',
    inActiveButtonTextColor: 'blue--text text--darken-3',
    buttonColor1: '',
    buttonTextColor1: '',
    buttonColor2: '',
    buttonTextColor2: '',
    buttonColor3: '',
    buttonTextColor3: '',
    rows: [],
    categoryBetsuDataList: [],
    sharyoBetsuDataList: [],
    nenkanHensachiDataList: [],
    conditions: {},
    addConditions: {},
    selected: [],
    target: [],
    modeKengen: 0,
    pageCount: 0,
    headerMode: 1
  }),
  components: {
    DdCodeTextBox,
    DdCustomButton,
    DdDataTable,
    DdDateRangeBox,
    DdDefaultButton,
    DdDropDown,
    DdNarrowDownTextBox,
    DdNenpiSummaryDisp,
    DdRadioButton,
    DdRowCountBox,
    DdSelectItemsPerPage,
    DdSubHeader,
    DdTextBox,
    DdTransparentButton,
    DdDropDownMulti,
    DdNenpiChartLineBar,
    DdIconButtonWithTooltip
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      eigyoshoList: 'DDMasters/mstEigyosho',
      nenpiCategoryList: 'DDMasters/mstNenpiCategory',
      currentKaishaCode: 'users/currentKaishaCode',
      usersEigyoshoCd: 'users/eigyoshoCd',
      helpUseFlg: 'users/helpUseFlg'
    }),
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        if (elem.count) {
          elem.konkaiNenpi = elem.konkaiNenpi / elem.count
          elem.zengetsuNenpi = elem.zengetsuNenpi / elem.count
          elem.zennenNenpi = elem.zennenNenpi / elem.count
        }
        elem.konkaiNenpiDisp = elem.konkaiNenpi ? filter.numericFormatter(elem.konkaiNenpi) : ''
        elem.kyuyuKingakuHensachiDisp = elem.kyuyuKingakuHensachi ? filter.numericFormatter(Math.abs([elem.kyuyuKingakuHensachi])) : ''
        return elem
      }).sort((a, b) => {
        if (a.mstSharyoNm > b.mstSharyoNm) { return 1 }
        if (a.mstSharyoNm === b.mstSharyoNm) { return 0 }
        return -1
      }).sort((a, b) => {
        if (a.eigyoshoCd > b.eigyoshoCd) { return 1 }
        if (a.eigyoshoCd === b.eigyoshoCd) { return 0 }
        return -1
      }).sort((a, b) => {
        if (a.hyojiOrder > b.hyojiOrder) { return 1 }
        if (a.hyojiOrder === b.hyojiOrder) { return 0 }
        return -1
      })
    },
    dispHeader () {
      const header = [
        { text: 'ID', value: 'nenpiCategoryId', align: ' d-none' },
        { text: 'カテゴリ', value: 'nenpiCategoryNm', width: '150px' },
        { text: '実燃費', value: 'konkaiNenpiDisp', align: 'end', width: '40px' },
        { text: '指標比較', value: 'kyuyuKingakuHensachiDisp', align: 'end', width: '40px' }
      ]
      return header
    },
    // 営業所フィルター
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      const resultArray = this.eigyoshoList.filter(function (elem) {
        return elem.tekiyoStartYmd <= target && elem.tekiyoEndYmd >= target && elem.eigyoshoKbn !== '03'
      }).map(elem => {
        return {
          value: elem.id,
          text: `${elem.eigyoshoCd}:${elem.eigyoshoNm}`
        }
      })
      return resultArray
    },
    // 燃費カテゴリフィルター
    filteredNenpiCategoryList () {
      var defArray = [{ value: 0, text: 'カテゴリ未設定' }]
      const resultArray = this.nenpiCategoryList.filter(function (elem) {
        return elem.hyojiFlg === true
      }).map(elem => {
        return {
          value: elem.id,
          text: `${elem.nenpiCategoryCd}:${elem.nenpiCategoryNm}`
        }
      })
      return defArray.concat(resultArray)
    },
    // Excelボタン活性条件
    isExcelButtonDisabled () {
      return this.rows.length === 0
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize () {
      console.log('initialize')
      const self = this
      const opt = {
        loadMasters: ['msteigyosho', 'mstnenpicategory'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('PrmHaishaList.defineHeaderPromise')
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('PrmHaishaList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            this.loadFromCache()
              .then((c) => {
                console.log('PrmHaishaList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('PrmHaishaList.researchPromise', c)
          return new Promise(resolve => {
            if (c.cache.value) {
              self.conditions = c.cache.value.conditions || {}
            }
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('PrmHaishaList.restoreViewPromise', c)
          return new Promise(resolve => {
            if (c.cache.value) {
              self.conditions = c.cache.value.conditions || {}
              self.searchText = c.cache.value.searchText || ''
              self.rows = c.cache.value.rows || []
            }
            resolve()
          })
        },
        settingViewScroll: () => {
          return false
        },
        settingButtonStatePromise: (kengen) => {
          console.log('PrmHaishaList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            self.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
              self.onReloadButtonClick()
            })

            resolve()
          })
        }
      }
      self.initializeForViewer(opt)
    },
    onReloadButtonClick: function (e) {
      this.onNenpiCategoryBetsuSearchButtonClick()
      this.onNenkanHensachiSearchButtonClick()
      this.$refs.nenpiSummaryDisp.searchNenpiSummary(this.conditions.searchTargetStartYmdString, this.conditions.searchTargetEndYmdString)
    },
    onNenpiCategoryBetsuSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/D2FUED0040/NenpiCategoryBetsuSearch', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.categoryBetsuDataList = data.payload
          self.categoryBetsuListFilter()
          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      this.search(opt)
    },
    // 選択されている営業所に一致するデータを、カテゴリ別に集計する。
    categoryBetsuListFilter: function (e) {
      const self = this
      let targetList = Object.assign([], self.categoryBetsuDataList)
      if (self.addConditions.eigyoshoIdList.length > 0) {
        targetList = targetList.filter(function (elem) {
          return self.addConditions.eigyoshoIdList.includes(elem.eigyoshoId)
        })
      }
      if (self.addConditions.nenpiCategoryIdList.length > 0) {
        targetList = targetList.filter(function (elem) {
          return self.addConditions.nenpiCategoryIdList.includes(elem.nenpiCategoryId)
        })
      }
      const resultList = targetList.reduce((result, current) => {
        const element = result.find((p) => p.nenpiCategoryId === current.nenpiCategoryId)
        if (element) {
          element.count++
          element.konkaiNenpi += current.konkaiNenpi
          element.kyuyuKingakuHensachi += current.kyuyuKingakuHensachi
          element.kyuyuRyo += current.kyuyuRyo
          element.sokoKyori += current.sokoKyori
          element.zengetsuNenpi += current.zengetsuNenpi
          element.zennenNenpi += current.zennenNenpi
        } else {
          result.push({
            nenpiCategoryId: current.nenpiCategoryId,
            nenpiCategoryCd: current.nenpiCategoryCd,
            nenpiCategoryNm: current.nenpiCategoryNm,
            hyojiOrder: current.hyojiOrder,
            count: 1,
            konkaiNenpi: current.konkaiNenpi,
            kyuyuKingakuHensachi: current.kyuyuKingakuHensachi,
            kyuyuRyo: current.kyuyuRyo,
            sokoKyori: current.sokoKyori,
            zengetsuNenpi: current.zengetsuNenpi,
            zennenNenpi: current.zennenNenpi
          })
        }
        return result
      }, [])
      console.log(resultList)
      this.rows = Object.assign([], resultList)
    },
    onNenkanHensachiSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/D2FUED0040/KyuyuJissekiNenkanHensachiSearch', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.nenkanHensachiDataList = data.payload
          self.$refs.nenpiChartLineBar.setDataListFromMainVue(self.conditions.searchTargetEndYmdString, self.addConditions.eigyoshoIdList, self.addConditions.nenpiCategoryIdList, self.nenkanHensachiDataList)
        },
        getSavedInputMethod: function () {
          return {}
        },
        isNoMessageModeMethod: function () {
          return true
        }
      }
      this.search(opt)
    },
    onInputAddConditions: function (e) {
      this.$refs.nenpiSummaryDisp.calcDispKingaku(this.addConditions.eigyoshoIdList, this.addConditions.nenpiCategoryIdList)
      this.categoryBetsuListFilter()
      this.$refs.nenpiChartLineBar.calcDispKingaku(this.conditions.searchTargetEndYmdString, this.addConditions.eigyoshoIdList, this.addConditions.nenpiCategoryIdList)
    },
    inputSerchTargetYmd: function (from, to) {
      this.onReloadButtonClick()
    },
    // --------------------------------------------------------------------------------
    // 初期値設定
    // --------------------------------------------------------------------------------
    initBindVariables: function () {
      const self = this
      const d = new Date()
      const initConditions = {
        searchTargetStartYmdString: date.getFirstDate(d.getFullYear(), d.getMonth() + 1),
        searchTargetEndYmdString: date.getLastDate(d.getFullYear(), d.getMonth() + 1)
      }
      const initAddConditions = {
        eigyoshoIdList: [],
        nenpiCategoryIdList: []
      }
      self.conditions = initConditions
      self.addConditions = initAddConditions
      self.headerMode = 1
      self.searchText = ''
      self.rows = []
    },
    // 検索前チェック
    searchValidate: function () {
      // 発生年月日不整合チェック
      if (this.conditions.searchTargetStartYmdString && this.conditions.searchTargetEndYmdString) {
        const msg1 = validators.compareDate(this.conditions.searchTargetStartYmdString, this.conditions.searchTargetEndYmdString)
        if (msg1 !== undefined) {
          this.$refs.searchTargetStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
          modals.showToastMessage('COME0014', null, 500, null, 'error')
          return false
        }
      } else {
        modals.showToastMessage('COME0008', null, 500, null, 'error')
        return false
      }
      return true
    },
    onDummyFunction: function () {
      return null
    }
  }
}
